import { slideDown, slideUp } from "../../components/GLOBAL";

document.addEventListener('DOMContentLoaded', function () {

 document.querySelectorAll('.vacancy').forEach((item)=>{
	const head = item.querySelector('.vacancy__top')
	const body = item.querySelector('.vacancy__body')
	if(item.classList.contains('_open')){
		slideDown(body)
	}
	head.addEventListener('click',()=>{
		if(item.classList.contains('_open')){
			item.classList.remove('_open')
			slideUp(body)
		}else{
			item.classList.add('_open')
			slideDown(body)
		}
	})
  })
});